import { Text } from '@/components'
import { TextProps } from '@codeleap/web'

export const FeedUsername = (props: Partial<TextProps<any>> & { username: string }) => {
  return <Text
    text={`@${props.username}`}
    variants={['h5', 'color:neutral9']}
  />
}
